// Controls active state based on items in viewport
const activeItemsWatcher = new IntersectionObserver( assignActiveState, {
    root: document.root, //Codepen bug with default value?
    rootMargin: '0px',//Allows items to peek through without being 'active'
    threshold: 0.1
} );

// If item is in the viewport, set visible state
function assignActiveState( entries ) {
    entries.forEach( entry => {
        entry.target.dataset.visible = entry.isIntersecting;
    } );
}

document.querySelectorAll( '.fleetail' ).forEach( item => activeItemsWatcher.observe( item ) );